import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import {
  translationConstants,
  questionTypes,
  feedbackTypes,
  StorageKeys,
  globalSystemConstants,
  modeConstants,
  Directions,
} from "../../../../constants";
import { allSharedComponents } from "../../../../shared";
import { competitionActions } from "../../../../redux/actions";

const CompetitionsFeedbackForm = ({ setShow, feedbackData, mode }) => {
  const {
    setValue,
    register,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm();
  const initialFromData = {
    practionerCourseId: null,
    competitionParticipantId: 0,
    feedBackType: feedbackTypes.FEED_BACK_TYPE_COMPETITIONS,
    feedbackQuestions: [],
  };
  const activeStars = [1, 2, 3, 4, 5];
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { SpinnerContainer } = allSharedComponents;
  const [formData, setFormData] = useState(initialFromData);
  const [questions, setQuestions] = useState([]);
  const queryParameters = new URLSearchParams(window.location.search);
  const participentId = queryParameters.get("userId");
  const [decodedToken, setDecodeToken] = useState(null);
  const token = queryParameters.get("token");
  const onSubmit = (data) => {
    formData.competitionParticipantId = participentId;
    dispatch(
      competitionActions.saveCompetitionFeedback(formData, token, setShow)
    );
  };
  const competitionQuestions = useSelector(
    (state) => state.CompetitionReducer.competitionFeedbackQuestion
  );
  useEffect(() => {
    if (token && mode !== modeConstants.VIEW_MODE) {
      dispatch(competitionActions.getCompetitionQuestion(token));
    }
  }, [token, mode, dispatch]);

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  useEffect(() => {
    setQuestions(competitionQuestions);
  }, [competitionQuestions]);

  useEffect(() => {
    if (mode === modeConstants.VIEW_MODE) {
      setQuestions(feedbackData?.feedbackQuestions);
      setFormData({
        ...formData,
        feedbackQuestions: feedbackData?.feedbackQuestions,
      });
    }
  }, [feedbackData, mode]);

  const handleFormData = (data, value) => {
    const processedValue = String(value);
    const existingIndex = formData?.feedbackQuestions?.findIndex(
      (item) => item.id === data.id
    );
    if (existingIndex !== -1) {
      const updatedFeedbackQuestions = [...formData.feedbackQuestions];
      updatedFeedbackQuestions[existingIndex] = {
        ...updatedFeedbackQuestions[existingIndex],
        answer: processedValue,
      };
      setFormData({
        ...formData,
        feedbackQuestions: updatedFeedbackQuestions,
      });
    } else {
      setFormData({
        ...formData,
        feedbackQuestions: [
          ...formData.feedbackQuestions,
          {
            id: data.id,
            question: data.question,
            questionType: data.questionType,
            answer: processedValue,
          },
        ],
      });
    }
  };

  const getRadioCheckedValue = (data, value) => {
    const question = formData.feedbackQuestions.find(
      (item) => item.id === data.id
    );
    return question?.answer === value;
  };

  return (
    <Form
      validated
      className="col-12 px-5 py-4"
      onSubmit={handleSubmit(onSubmit)}
    >
      <span className="loginPara">
        {t(translationConstants.COMPETITION_FEEDBACK)}
      </span>
      <hr />
      <div className="col-12 row">
        {questions?.map((data, index) => (
          <div key={index} className="my-3 col-12 col-lg-6">
            {data.questionType === questionTypes.QUESTION_TYPE_STAR && (
              <>
                <p className="feedback-text">
                  {" "}
                  {direction === Directions.rtl
                    ? data?.arabicQuestion
                      ? data?.arabicQuestion
                      : data.question
                    : data.question}
                </p>
                {activeStars.map((star) => (
                  <span
                    key={star}
                    className={
                      star <=
                      parseInt(
                        formData?.feedbackQuestions?.find(
                          (item) => item.id === data.id
                        )?.answer || 0
                      )
                        ? mode === modeConstants.VIEW_MODE
                          ? `feedback-stars-disabled feedback-stars`
                          : `feedback-stars text-warning`
                        : "feedback-stars"
                    }
                    onClick={() => {
                      if (mode !== modeConstants.VIEW_MODE) {
                        setValue(`star${index}`, star);
                        trigger(`star${index}`);
                        handleFormData(data, star);
                      }
                    }}
                    {...register(`star${index}`, { required: true })}
                  >
                    &#9733;
                  </span>
                ))}
                <br />
                {errors[`star${index}`] && (
                  <p className="errorText">
                    {t(translationConstants.FIELD_IS_REQUIRED)}
                  </p>
                )}
              </>
            )}
            {data.questionType === questionTypes.QUESTION_TYPE_RADIO && (
              <>
                <p className="feedback-text">
                  {direction === Directions.rtl
                    ? data?.arabicQuestion
                      ? data?.arabicQuestion
                      : data.question
                    : data.question}
                </p>
                <div className="inputRow mt-2 d-flex">
                  <Form.Check
                    type="radio"
                    label={t(translationConstants.YES)}
                    name={`radioGroup${index}`}
                    id={`yes${index}`}
                    onClick={(e) => {
                      if (mode !== modeConstants.VIEW_MODE) {
                        handleFormData(data, "yes");
                      }
                    }}
                    disabled={mode === modeConstants.VIEW_MODE}
                    defaultChecked={getRadioCheckedValue(data, "yes")}
                    {...register(`radioGroup${index}`, { required: true })}
                  />

                  <Form.Check
                    type="radio"
                    label={t(translationConstants.NO)}
                    name={`radioGroup${index}`}
                    id={`no${index}`}
                    onClick={() => {
                      if (mode !== modeConstants.VIEW_MODE) {
                        handleFormData(data, "no");
                      }
                    }}
                    disabled={mode === modeConstants.VIEW_MODE}
                    defaultChecked={getRadioCheckedValue(data, "no")}
                    {...register(`radioGroup${index}`, { required: true })}
                  />
                </div>
              </>
            )}
            {errors[`radioGroup${index}`] && (
              <p className="errorText">
                {t(translationConstants.FIELD_IS_REQUIRED)}
              </p>
            )}
          </div>
        ))}
      </div>
      {mode === modeConstants.VIEW_MODE && (
        <>
          <div className="col-12 my-2">
            <p className="feedback-score-text">
              {t(translationConstants.FEEDBACK_SCORE)}:{" "}
              <span className="feedback-score-value">
                {feedbackData.averageScore}
              </span>
            </p>
          </div>
        </>
      )}
      {mode !== modeConstants.VIEW_MODE && (
        <Button className="SubmitDocs-button" type="submit">
          {t(translationConstants.submit)}
        </Button>
      )}
    </Form>
  );
};

export default CompetitionsFeedbackForm;